<template>
  <div
    v-if="modelValue"
    class="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50 px-4"
  >
    <div class="bg-white rounded-lg shadow-xl max-w-md w-full p-0 relative overflow-hidden mx-auto">
      <div class="flex transition-transform duration-300" :style="{ transform: `translateX(-${introPane * 100}%)` }">
        <!-- Pane 1 -->
        <div class="w-full max-w-md p-6 flex-shrink-0">
          <h2 class="text-xl font-bold mb-4">Welcome to Charmed!</h2>
          <p class="mb-6 text-gray-700">
            Charmed is a place for discovering and supporting <b>local</b> stores, events, products and services. Charmed needs access to location to find nearby businesses and events, and to verify check-ins for offers and rewards. We never share your location with third parties, and you can revoke access at any time in your browser settings.
          </p>
          <div class="flex justify-end">
            <button
              class="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded font-semibold"
              @click="nextPane"
            >
              Next
            </button>
          </div>
        </div>
        <!-- Pane 2 -->
        <div class="w-full max-w-md p-6 flex-shrink-0">
          <h2 class="text-xl font-bold mb-4">Discover & Earn</h2>
          <p class="mb-6 text-gray-700">
            Find coupons, events, and special offers from local businesses. Claim deals and coupons and redeem them in person by showing a QR code on your phone.
          </p>
          <div class="flex justify-end">
            <button
              class="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded font-semibold"
              @click="nextPane"
            >
              Next
            </button>
          </div>
        </div>
        <!-- Pane 3: Seller Benefits -->
        <div class="w-full max-w-md p-6 flex-shrink-0">
          <h2 class="text-xl font-bold mb-4">For Sellers & Venues</h2>
          <p class="mb-6 text-gray-700">
            Charmed helps sellers and venues reach local customers, promote events, and reward loyal fans. Easily create offers, manage redemptions, and grow your business with real community engagement.
          </p>
          <div class="flex justify-end">
            <button
              class="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded font-semibold"
              @click="nextPane"
            >
              Get Started
            </button>
          </div>
        </div>
      </div>
      <!-- Dots indicator -->
      <div class="absolute bottom-3 left-0 right-0 flex justify-center gap-2">
        <button
          v-for="(dot, idx) in 3"
          :key="idx"
          class="w-2 h-2 rounded-full"
          :class="introPane === idx ? 'bg-green-600' : 'bg-gray-300'"
          @click="goToPane(idx)"
          aria-label="Go to step"
        ></button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, defineEmits, defineProps } from 'vue';

const props = defineProps({
  modelValue: {
    type: Boolean,
    required: true
  }
});

const emit = defineEmits(['update:modelValue']);

const introPane = ref(0);

function nextPane() {
  if (introPane.value < 2) {
    introPane.value++;
  } else {
    closeIntroModal();
  }
}

function goToPane(idx) {
  introPane.value = idx;
}

function closeIntroModal() {
  emit('update:modelValue', false);
  localStorage.setItem('charmed_intro_seen', '1');
}
</script>
